import { Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const CARD_THUMBNAIL_WIDTH = '152px'

export const CarouselItemBox = styled(Box)`
  ${s({
    padding: 4,
    width: `${CARD_THUMBNAIL_WIDTH}`,
    height: '100%',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0,
  })}
`
